import USER_ROLES from "../../../constants/userRoles.constants";

class ProductsListController {
    constructor($filter, $state, listService, userService) {
        this.$filter = $filter;
        this.$state = $state;
        this.listService = listService;
        this.userService = userService;
        this.isAdmin = false;

        this.selected = [];
        this.editedByMe = false;
        this.query = {
            order: '-id',
        };
        this.products = [];
        this.visibleRowsLimit = 20;
    }

    $onInit() {
        this.isAdmin = this.userService.isInRole(USER_ROLES.ROLE_ADMIN);
        if(this.isAdmin) {
            this._getProducts(this.editedByMe);
        } else {
            this.editedByMe = true;
            this._getProducts(true);
        }
    }

    _getProducts(isMine) {
        this.listService.getAllProducts(isMine).then((res) => this.products = res)
            .catch(e => console.log('ERROR', e));
    }

    disableLimit(numberOfRecords) {
        this.visibleRowsLimit = numberOfRecords;
    }

    displayDate(input) {
        if (isNaN(input)) {
            return input;
        }

        return this.$filter('date')(`${input}000`, 'dd.MM.yyyy');
    }

    goToProduct(productId) {
        if(this.isAdmin) {
            this.$state.go('evaluationsList', {
                productId,
            });
        } else {
            this.$state.go('mini.basicInfo', {id: productId});
        }
    }

    findProducts(searchText) {
        searchText = searchText ? searchText.trim() : '';
        if (searchText) {
            this.listService.searchProducts(searchText, self.editedByMe).then((res) => {
                this.products = res;
            }).catch(e => console.log('ERROR', e));
        } else {
            this._getProducts();
        }
    }

    switchEvaluationsMode(editedByMe) {
        this.editedByMe = editedByMe;
        this._getProducts(editedByMe);
    }

    printExpireComment(date) {
        if(date) {
            date = (new Date(date)).setMinutes(0,0,0);
            let now = (new Date()).setHours(0,0,0);
            const days = Math.floor((date - now) / (1000 * 60 * 60 * 24));
            if(days > 0) {
                return 'expires in ' + days + ' days';
            } else if(days < 0) {
                return 'expired ' + (-days) + ' days ago';
            } else {
                const hours = Math.floor((date - now) / (1000 * 60 * 24));

                if(hours >= 0) {
                    return 'expires in ' + hours + ' hours';
                } else if(hours < 0) {
                    return 'expired ' + (-hours) + ' hours ago';
                }
            }
        }
    }
}

ProductsListController.$inject = [
    '$filter',
    '$state',
    'ListService',
    'UserService'
];

export default ProductsListController;



// WEBPACK FOOTER //
// ./src/app/pages/lists/productsList/productsListController.js